module.exports = __webpack_public_path__ + "img/zhangjiagang.e1d848a.png";